import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as OrderStatusModels from '../../models/order/orderStatus';
import * as OrderTypeModels from '../../models/order/orderType';
import * as TyreChangeOrderModels from '../../models/tyre-change-order/tyre-change-order';
import { TyreChangeOrderSearchModel } from '../../models/tyre-change-order/tyre-change-orderSearch';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as Models from '../../models/commonModels';

@Injectable({
  providedIn: 'root'
})

export class TyreChangeOrderService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  public getList(Search: TyreChangeOrderSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    return this.httpClient.post<TyreChangeOrderModels.TyreChangeOrderListModel>(`${this.environmentService.getApiURL()}/tyre-change-order/list`, Search, options);
  }

  public getStatusDictionary() {
    return this.httpClient.get<OrderStatusModels.OrderStatusListModel>(`${this.environmentService.getApiURL()}/tyre-change-order/status`);
  }

  public set(TyreReturnOrder: Models.Request<TyreChangeOrderModels.TyreChangeOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreChangeOrderModels.TyreChangeOrderModel>>(`${this.environmentService.getApiURL()}/tyre-change-order/set`, TyreReturnOrder, options);
  }

  public get(Order: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreChangeOrderModels.TyreChangeOrderModel>>(`${this.environmentService.getApiURL()}/tyre-change-order/get`, Order, options);
  }
}
